// extracted by mini-css-extract-plugin
export default {"block":"About_block__RFp81","infoBlock":"About_infoBlock__yj6VC","title":"About_title__ro4qI","text":"About_text__GKTuZ"};